import { Icon } from "semantic-ui-react"
import type { OpenAPI } from "simplydo/interfaces"

import { TooltipButton } from "components/lib/UI"

type DownloadCoverImageActionProps = {
  idea: OpenAPI.GET<"/ideas/{id}">["response"]
}

const DownloadCoverImageAction = ({ idea }: DownloadCoverImageActionProps) => {
  if (idea?.ownerChallenge?.preventIdeaCoverImages || !idea?.coverImage) {
    return null
  }

  return (
    <TooltipButton
      as="a"
      href={idea.coverImageUrl}
      target="_blank"
      rel="noopener noreferrer"
      download={idea?.coverImage}
      icon
      tooltip="Download cover image"
    >
      <Icon name="download" />
    </TooltipButton>
  )
}

export default DownloadCoverImageAction
